import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { DashboardProps, ProductionLibraryProps } from "./Dashboard";
const Dashboard = lazy(() => import("./Dashboard").then(module => ({ default: module.Dashboard })));
const ProductionLibrary = lazy(() => import("./Dashboard").then(module => ({ default: module.ProductionLibrary })));
export function mountDashboard(slot: HTMLElement, props: DashboardProps) {
  setStudioView("app", "dashboard", <Dashboard {...props} />);
}
export function mountProductionLibrary(slot: HTMLElement, props: ProductionLibraryProps) {
  setStudioView("app", "production-library", <ProductionLibrary {...props} />);
}
